/**
 * Map display helpers for navigation UI.
 *
 * Routing lives in ./navigation.ts (Valhalla via Coordal API).
 */

import type { TravelMode } from './navigation';

export type {
  Coordinates,
  DirectionsOptions,
  DirectionsResponse,
  Route,
  RouteStep,
  TravelMode,
} from './navigation';

export { getDirections, transformDirectionsEnvelope } from './navigation';

/**
 * Format distance for display
 */
export function formatDistance(meters: number, unit: 'km' | 'mi' = 'km'): string {
  if (unit === 'mi') {
    const feet = meters * 3.28084;
    if (feet < 1000) {
      return `${Math.round(feet)} ft`;
    }
    return `${(meters / 1609.344).toFixed(1)} mi`;
  }
  if (meters < 1000) {
    return `${Math.round(meters)} m`;
  }
  return `${(meters / 1000).toFixed(1)} km`;
}

/**
 * Format duration for display
 */
export function formatDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours > 0) {
    return `${hours} hr ${minutes} min`;
  }
  return `${minutes} min`;
}

/**
 * Get travel mode label
 */
export function getTravelModeLabel(mode: TravelMode): string {
  const labels: Record<TravelMode, string> = {
    'driving': 'Drive',
    'driving-traffic': 'Drive (Traffic)',
    'walking': 'Walk',
    'cycling': 'Bike',
    'transit': 'Transit',
  };
  return labels[mode] || 'Drive';
}
